import React, {Component} from 'react';
import Detalle from './Detalle';
import Actualidad from './';
import Utils from '../utils';

class WithData extends Component {
  constructor(){
    super();
    this.state = {
      data : "",
      cardsChar : "",
      cardsArt : "",
      cardsMed : "",
      cardsConv : "",
      cardsMisc : ""
    }
  }

  componentDidMount(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Actualidad", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var totalArticulos = data.records.filter(record => record.fields.Activo === true)
      
      var arrChar = [];
      var arrArt = [];
      var arrMed = [];
      var arrConv = [];
      var arrMisc = [];

      totalArticulos.forEach(element => {

        if (element.fields.SubGrupo){
          switch (element.fields.SubGrupo[0]){
            case "charlas":
              arrChar.push(element);
              break;
            case "articulos":
              arrArt.push(element);
              break;
            case "medios":
              arrMed.push(element);
              break;
            case "convocatorias":
              arrConv.push(element);
              break;
            
            default:
              arrMisc.push(element);
          }
        }
        else {
          arrMisc.push(element);
        }
      });
      
      arrChar = Utils.newestFirst(arrChar, "fechaOrganizacional")
      arrArt = Utils.newestFirst(arrArt, "fechaOrganizacional")
      arrMed = Utils.newestFirst(arrMed, "fechaOrganizacional")
      arrConv = Utils.newestFirst(arrConv, "fechaOrganizacional")
      arrMisc = Utils.newestFirst(arrMisc, "fechaOrganizacional")

      this.setState({
        data: totalArticulos,
        cardsChar : arrChar,
        cardsArt : arrArt,
        cardsMed : arrMed,
        cardsConv : arrConv,
        cardsMisc : arrMisc
      });
    })
    .catch(error=>{
      console.error(error);
    })
  }

  
  // Si vienen por un link permanente, debo renderizar la noticia (componente Detalle)
  render(){
    let id = this.props.match.params.id;
    if(id && this.state.data.length > 0){
      const arr = this.state.data.filter(notas=>notas.id === id)[0];
      const detalleState = {
        image : arr.fields.Imagen[0].thumbnails.large.url,
        video: arr.fields.Video,
        date: arr.fields.Fecha,
        title: arr.fields.Titulo,
        description: arr.fields.Descripcion,
        info: arr.fields.Info,
        key: 'card1'
      }
      return (<Detalle state={detalleState}/>);
    }
    else
      return (<Actualidad cards={this.state.data} 
                          cardsChar={this.state.cardsChar} 
                          cardsConv={this.state.cardsConv} 
                          cardsArt={this.state.cardsArt}
                          cardsMed={this.state.cardsMed}
                          cardsMisc={this.state.cardsMisc}/>
                );
  }
}

export default WithData;
